export const FEATURES = {
  OPS_FOOTER_GOOGLE_REVIEWS: 'ops_footer_google_reviews',
  RELEASE_BUYER_APPLICATION_AUTH_REMOVAL:
    'release_buyer_application_auth_removal',
  REL_UPDATED_LITTER_FLOW: 'rel_updated_litter_flow',
  REL_BREEDER_SHARE_PAYMENT_INFO: 'rel_breeder_share_payment_info',
  REL_BREEDER_UPDATES: 'rel_breeder_updates',
  REL_REVIEWS_PAGE: 'rel_reviews_page'
};
